import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface AccordionItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function AccordionItem({
  question,
  answer,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border-b border-navy-700 last:border-0" data-id="element-199">
      <button className="w-full py-5 flex justify-between items-center text-left focus:outline-none group" onClick={onClick} data-id="element-200">
        <span className="font-heading font-bold text-lg md:text-xl text-white group-hover:text-brand-light transition-colors" data-id="element-201">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} className="flex-shrink-0 ml-4 text-brand-orange" data-id="element-202">
          <ChevronDownIcon className="h-6 w-6" data-id="element-203" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-204">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-205">
            <div className="pb-5 text-gray-300 leading-snug" data-id="element-206">{answer}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
interface AccordionProps {
  items: {
    question: string;
    answer: string;
  }[];
}
export function Accordion({
  items
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="bg-navy-800 rounded-2xl p-6 md:p-8 border border-navy-700 shadow-xl" data-id="element-207">
      {items.map((item, index) => <AccordionItem key={index} question={item.question} answer={item.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-208" />)}
    </div>;
}